import React from "react";

/**
 * GlobalPattern
 * Renders ONE truly-fixed viewport-anchored pattern layer at the root of
 * the app. Fixes the mobile "pattern scrolls with the page" issue caused
 * by `background-attachment: fixed` being unsupported on iOS Safari and
 * most Chrome mobile builds. Because the element itself is `position:
 * fixed`, it stays anchored on every browser.
 *
 * Placed as the very first child under body so all app content stacks on
 * top of it (see `body > * { z-index: 1 }` in index.css).
 */
export default function GlobalPattern() {
  return (
    <div
      aria-hidden="true"
      data-testid="global-pattern-layer"
      style={{
        position: "fixed",
        inset: 0,
        backgroundImage: `url(${process.env.PUBLIC_URL}/pattern-aexents.png)`,
        backgroundRepeat: "repeat",
        backgroundSize: "520px auto",
        backgroundPosition: "center top",
        opacity: 0.09,
        pointerEvents: "none",
        zIndex: 0,
      }}
    />
  );
}
